// src/pages/CGU.jsx
import React from "react";
import NavBar from "../components/layout/NavBar";
import Footer from "../components/layout/Footer";

export default function CGU() {
  return (
    <main className="min-h-screen bg-white text-gray-900">
      <NavBar />

      <section className="px-6 pt-6 pb-2">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-4xl font-semibold leading-tight">Conditions Générales d’Utilisation</h1>
          <p className="mt-3 text-sm text-gray-600">En vigueur au 10/08/2025</p>
        </div>
      </section>

      <section className="px-6 pb-24">
        <div className="max-w-3xl mx-auto space-y-8 text-[15px] leading-7">

          <p>
            Les présentes conditions générales d’utilisation (« <strong>CGU</strong> ») régissent l’accès et la navigation
            sur le site <strong>pacte-claix.fr</strong> (le « <strong>Site</strong> »). En accédant et en utilisant ce Site, 
            vous acceptez sans réserve les présentes CGU.
          </p>

          <section>
            <h2 className="text-xl font-semibold mb-2">ARTICLE 1 — Mentions légales</h2>
            <p>
              Éditeur : <strong>Association PACTE (Promouvons nos Acteurs Claixois Tous Ensemble)</strong><br/>
              Forme : Association loi 1901<br/>
              Siège social : <em>106 ARBOREA, 2 RUE AIME SERRES, 38640 Claix, France</em><br/>
              Email : <a href="mailto:contact@pacte-claix.fr" className="underline">contact@pacte-claix.fr</a><br/>
              Directeur de la publication : <em>FAURE Kinan</em>
            </p>
            <p className="mt-3">
              Hébergeur : <strong>OVH SAS</strong>, 2 rue Kellermann, 59100 Roubaix, France — Tél : +33 9 72 10 10 07
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-2">ARTICLE 2 — Accès au Site</h2>
            <p>
              Le Site est accessible gratuitement à tout utilisateur disposant d’un accès Internet.
              Les frais de connexion sont à la charge de l’Utilisateur. L’association PACTE s’efforce
              d’assurer un accès de qualité mais ne peut garantir une disponibilité permanente et
              se réserve le droit de suspendre l’accès pour maintenance ou mise à jour.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-2">ARTICLE 3 — Contenu du Site</h2>
            <p>
              Le Site a pour objectif de présenter l’association PACTE, ses actions et l’application mobile
              associée. Les informations publiées le sont à titre indicatif. Malgré des mises à jour régulières,
              l’association ne peut garantir l’exactitude et l’exhaustivité des contenus.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-2">ARTICLE 4 — Propriété intellectuelle</h2>
            <p>
              L’ensemble des éléments du Site (textes, images, graphismes, logos, etc.) est protégé par
              la législation en vigueur. Toute reproduction ou utilisation sans autorisation écrite est interdite.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-2">ARTICLE 5 — Liens externes</h2>
            <p>
              Le Site peut contenir des liens vers d’autres sites. L’association PACTE n’exerce aucun contrôle
              sur ces sites et décline toute responsabilité concernant leur contenu ou leur accessibilité.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-2">ARTICLE 6 — Données personnelles</h2>
            <p>
              Le Site peut recueillir certaines données via son formulaire de contact (nom, email, message).
              Ces données sont utilisées uniquement pour répondre aux sollicitations et ne sont jamais cédées
              à des tiers. Conformément au RGPD, vous pouvez exercer vos droits (accès, rectification, suppression)
              en écrivant à <a href="mailto:contact@pacte-claix.fr" className="underline">contact@pacte-claix.fr</a>.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-2">ARTICLE 7 — Responsabilité</h2>
            <p>
              L’association PACTE ne pourra être tenue responsable des dommages directs ou indirects
              résultant de l’utilisation du Site, ni des interruptions ou indisponibilités.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-2">ARTICLE 8 — Droit applicable</h2>
            <p>
              Les présentes CGU sont régies par le droit français. En cas de litige, les tribunaux compétents
              du ressort de <em>Grenoble</em> seront seuls compétents.
            </p>
          </section>

        </div>
      </section>

      <Footer />
    </main>
  );
}